// Build60 albumRegionCache: preserve a loaded list, then re-read its boundary on continuation.
export function correctTimelineSnapshot(data, filters, albumId, displayRegion) {
  let found = false;
  const update = (items) =>
    (items || []).flatMap((item) => {
      if (item.album.id !== albumId) return [item];
      found = true;
      if (filters.region !== 'all' && (filters.region === 'kr') !== (displayRegion === 'KR'))
        return [];
      return [
        {
          ...item,
          album: {
            ...item.album,
            displayRegion,
            originRegion: displayRegion,
            originConfidence: 100,
          },
        },
      ];
    });
  const pages = data.pages.map((page) => ({
    ...page,
    rediscoveredAlbums: update(page.rediscoveredAlbums),
    openingAlbums: update(page.openingAlbums),
  }));
  if (!found) return undefined;
  const field = filters.section === 'opening' ? 'openingAlbums' : 'rediscoveredAlbums';
  const count = new Set(pages.flatMap((p) => p[field].map((item) => item.album.id))).size;
  if (pages.length) pages[pages.length - 1].resumePage = Math.floor(count / 20) + 1;
  return { ...data, pages };
}
export async function applyTimelineRegionCorrection(client, albumId, displayRegion) {
  const match = (q) =>
    q.queryKey[0] === 'web-parity' && ['timeline-preview', 'timeline-all'].includes(q.queryKey[1]);
  await client.cancelQueries({ predicate: match });
  for (const query of client.getQueryCache().findAll({ predicate: match })) {
    const key = query.queryKey;
    const patch =
      key[2] === 'section60' && query.state.data
        ? correctTimelineSnapshot(query.state.data, key[6], albumId, displayRegion)
        : undefined;
    if (patch) client.setQueryData(key, patch);
    else
      await client.invalidateQueries({
        queryKey: key,
        exact: true,
        refetchType: key[1] === 'timeline-preview' ? 'active' : 'none',
      });
  }
}
